import { useTranslation } from 'next-i18next';
import { BoltFillIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { cn } from '@/utils';
export const UpgradeButton = ({
  onClick,
  className
}: {
  onClick: VoidFunction;
  className?: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <Button className={cn('w-full', className)} variant="contained" intent="gradient" size="lg" leftSlot={<BoltFillIcon size="sm" />} onClick={onClick} data-sentry-element="Button" data-sentry-component="UpgradeButton" data-sentry-source-file="UpgradeButton.tsx">
      {t('common:planUpgrade')}
    </Button>;
};